'use strict';

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.is-integer");

Number.isInteger = Number.isInteger || function (value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};